export const buttonProps = {
  /**
   * @description 原生属性
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 原生属性
   */
  loading: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'default',
  },
  size: {
    type: String,
    default: 'large',
  },
  link: {
    type: String,
    default: '',
  },
};
